import { render, staticRenderFns } from "./qrAddressUpdate.vue?vue&type=template&id=0ddc0b4e&scoped=true"
import script from "./qrAddressUpdate.vue?vue&type=script&lang=js"
export * from "./qrAddressUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddc0b4e",
  null
  
)

export default component.exports